import { PromocodeStatus, PromocodeType } from "./Enums";

export class Promocode {
    ID: string;
    CODE: string;
    DISCOUNT_PERCENT: number;
    VALID_FROM: any;
    VALID_TILL: any;
    STATUS: PromocodeStatus;
    ACTIVATIONS: number;
    TYPE: PromocodeType;

    static parse(json: any): Promocode {
        if (json) {
            const p = new Promocode();

            p.ID = json.ID;
            p.CODE = json.CODE;
            p.DISCOUNT_PERCENT = json.DISCOUNT_PERCENT;
            p.VALID_FROM = json.VALID_FROM;
            p.VALID_TILL = json.VALID_TILL;
            p.STATUS = PromocodeStatus[<string>json.STATUS];
            p.ACTIVATIONS = json.ACTIVATIONS;
            p.TYPE = PromocodeType[<string>json.TYPE];

            return p;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<Promocode> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(Promocode.parse(j));

        return arr;
    }

}
